<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.professions', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @reset="onReset" v-if="show">
                    <b-container>
                        <b-row>
                            <div class="col-sm-12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="nom-group"
                                        :label="$t('message.name')"
                                        label-for="nom"
                                        description=""
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.name.$model"
                                            :state="$v.form.name.$dirty ? !(errorshasField('name') || $v.form.name.$error) : null"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('name')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.name.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.name.minLength">
                                        {{ $t('message.minCharacters', { n: 3 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-else-if="errorshasField('name')">
                                        {{ getErrorsField('name') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                        </b-row>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.edit') }}
                            </b-button>

<!--                            <b-button type="reset" variant="danger">-->
<!--                                {{ $t('message.reset') }}-->
<!--                            </b-button>-->
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import {minLength, required} from 'vuelidate/lib/validators';

    export default {
        name: "EditProfession",

        computed: {
            ...mapGetters(["profession", "errors",'hasAdminRole',
                'hasGestionnaireRole']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },
            form: function() {
                return this.profession;
            }
        },

        data() {
            return {
                profession_id: this.$route.params.profession,
                show: true
            }
        },

        methods: {
            getProfession: function() {
                let args = {
                    profession: this.profession_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getProfession', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        profession: this.profession_id,
                        name: this.form.name
                    };

                    let successMessage = this.$i18n.t('message.professionUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateProfession', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                /*evt.preventDefault();

                // Reset our form values
                this.form.nom = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });*/
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                name: {
                    required,
                    minLength: minLength(3)

                }
            }
        },

        mounted() {
            // Retrieve profession
            this.getProfession();
        }
    }
</script>

<style scoped>

</style>